import React from 'react';
import { Form } from 'react-bootstrap';
import Select, { components } from 'react-select';
import styles from '../../pa_checklist_followup.module.scss';

const CustomValueContainer = ({ children, ...props }) => {
  const selectedCount = props.getValue().length;
  const inputValue = props.selectProps.inputValue;

  return (
    <components.ValueContainer {...props}>
      {inputValue === '' && (
        <div style={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '100%',
          pointerEvents: 'none',
          color: '#999',
        }}>
          {selectedCount > 0
            ? `${selectedCount} ${selectedCount > 1 ? 'selecionados' : 'selecionado'}`
            : 'Selecionar'}
        </div>
      )}
      {React.Children.map(children, child =>
        child && child.type !== components.Placeholder ? child : null
      )}
    </components.ValueContainer>
  );
}

const customOption = (props) => {
  const { isSelected, label } = props;
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => {}}
        style={{ marginRight: 8 }}
      />
      {label}
    </components.Option>
  );
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#e6f7ff' : 'white',
    color: 'black',
  }),
  multiValue: () => ({
    display: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    padding: '0px 0px 0px 8px',
    cursor: 'pointer',
    minHeight: '36px',
    minWidth: '164px',
    borderColor: state.isFocused ? '#2684FF' : '#ddd',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0',
    height: '36px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    position: 'absolute',
    right: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    display: 'none',
  }),
}

export default function MultiCheckboxSelect({ value, onChange, options, placeholder, width }) {
  return (
    <div style={{ zIndex: 3, width: width }}>
      <Form.Label className={styles.form_label}>{placeholder}</Form.Label>
      <Select
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isMulti
        options={options}
        components={{
          Option: customOption,
          ValueContainer: CustomValueContainer,
        }}
        onChange={onChange}
        value={value}
        styles={customStyles}
        placeholder={placeholder}
        isSearchable={true}
      />
    </div>
  );
}
